import { takeLatest, takeEvery, fork, put, all, call } from 'redux-saga/effects'

import i18n from 'i18n'
import { jobInvitesAPI } from '../../../../api'
import { jobInviteInvitesSentList } from './slice'
import { RequestUtils } from 'utils'
import { authLogoutPA } from 'features/auth/store'

export function* getList({ payload: { params } }) {
  try {
    let requestParams = {
      includes: ['job', 'receiver'],
    }

    requestParams = RequestUtils.getMapRequestParams(params, requestParams)

    const response = yield call(jobInvitesAPI.getSentInvites, requestParams)

    const { data } = response

    const {
      meta: { current_page, last_page },
    } = data

    if (current_page && last_page && current_page > last_page) {
      yield put(
        jobInviteInvitesSentList.getList({
          params: {
            ...params,
            page: last_page,
          },
        })
      )
    } else {
      yield put(jobInviteInvitesSentList.getListSuccess(data))
    }
  } catch (error) {
    const message = error.response?.data?.message || i18n.t('error')
    yield put(jobInviteInvitesSentList.getListError(message))
  }
}

export function* watchGetList() {
  yield takeLatest(jobInviteInvitesSentList.getList, getList)
}

function* cleanState() {
  yield put(jobInviteInvitesSentList.cleanState({}))
}

function* watchUserLogout() {
  yield takeEvery(authLogoutPA.success, cleanState)
}

export function* listSaga() {
  yield all([fork(watchGetList), fork(watchUserLogout)])
}
